<template>
  <div class="display-wrapper fullscreen-wrapper">
    <fullscreen :fullscreen.sync="isFullscreen">
      <div class="display-content" v-if="toReload">
        <div class="column left">
          <div class="row class-all">
            <div class="com-wrapper">
              <statistical-com
                :propsOrgName="propsOrgName"
                :numStatistical="propsNumStatistical"
              ></statistical-com>
            </div>
          </div>
          <div class="row class-all">
            <div class="h290">
              <waterFall-com
                :propsOnlineCoachCount.sync="onlineCoachCount"
                :propsReloadTime="reloadTime"
              ></waterFall-com>
            </div>
          </div>
          <div class="row class-all">
            <div class="pie-wrapper">
              <pie-com
              :propsOrgName="propsOrgName"
              :propsReloadTime="reloadTime"
              ></pie-com>
            </div>
          </div>
        </div>
        <div class="column center">
          <div class="map-canvas" style="position: relative">
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: -44px;
                left: 0;
              "
            >
              <span @click="toggleApi">
                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                <span class="fullscreen-btn" v-else>退出全屏</span>
              </span>
            </div>
            <div class="map-title">
              <!-- {{ year }}年各省/自治区/直辖市/特别行政区开班数量 -->
              {{ propsOrgName }}开班数量（2019年至今）
            </div>
            <div class="echart-map-wrapper">
              <map-com
                :propsOrgName.sync="propsOrgName"
                :provinceName="mapProvinceName"
                :dataList="provinceDataList"
                :domName="mapName"
                :propsNumStatistical.sync="propsNumStatistical"
                :propsReloadTime="reloadTime"
              ></map-com>
            </div>
          </div>
          <div class="row class-all" style="margin-top:1em">
            <div class="line-wrapper">
              <template v-if="isShowChild">
                <line-com
                  :propsOrgName="propsOrgName"
                  :userCount="propsUserCount"
                  :userRankAll="userRankAll"
                  :lineChartsData="propsLineChartsData"
                ></line-com>
              </template>
            </div>
          </div>
        </div>
        <div class="column right">
          <div class="row class-all">
            <!-- 全部教案统计 -->
            <div class="toturial-wrapper">
              <toturial-com
              :propsOrgName="propsOrgName"
              ></toturial-com>
            </div>
          </div>
          <div class="row class-all">
            <div class="grade-wrapper">
              <template v-if="isShowChild">
                <tutorial-line-com
                  ref="gradCom"
                  :propsOrgName="propsOrgName"
                  :passSeriesData="propsPassSeriesData"
                  :failSeriesData="propsFailCoachCount"
                  :passRateSeriesData="propsPassRate"
                ></tutorial-line-com>
              </template>
            </div>
          </div>
          <div class="row class-all">
            <div class="login-wrapper">
              <!-- <template v-if="isShowChild">
                <login-line
                  :onlineCoachCount="onlineCoachCount"
                  :propsLoginInfo="propsLoginInfo"
                  :propsReloadTime="reloadTime"
                ></login-line>
              </template> -->
              <template v-if="isShowChild">
                <teacher-com
                  :propsOrgName="propsOrgName"
                  :propsTeacherList="propsTeacherList"
                ></teacher-com>
              </template>
            </div>
          </div>
        </div>
      </div>
    </fullscreen>
  </div>
</template>

<script>
import VueFullscreen from "vue-fullscreen";
import Vue from "vue";
import { getCoachStatisticalOrgan } from "@/api/display/province";
import { storageData } from "@/assets/js/storage";
Vue.use(VueFullscreen);

export default {
  data() {
    return {
      fullscreen: false,
      isFullscreen: false,
      toReload: true,
      mapName: "echartsTestProvince",
      provinceDataList: [
        {
          name: "郑州市",
          value: 199,
        },
        {
          name: "周口市",
          value: 99,
        },
        {
          name: "洛阳市",
          value: 599,
        },

        // 测试用青岛地区地图
        {
          name: "即墨",
          value: 200,
        },
        {
          name: "黄岛",
          value: 280,
        },

        // 测试用北京数据
        {
          name: "西城区",
          value: 999,
        },
        {
          name: "东城区",
          value: 499,
        },
        // 测试用重庆数据
        {
          name: "万州区",
          value: 799,
        },
        // 海南测试数据
        {
          name: "海口市",
          value: 666,
        },
      ],
      mapProvinceName: "河南",
      propsFailCoachCount: [],
      propsPassSeriesData: [],
      propsPassRate: [],
      isShowChild: true,
      propsUserCount: {
        // 系统内数据
        userInfoCount: 0,
        userInfoCountMonth: 0,
        userInfoCountDay: 0,
      },
      userRankAll:0,// 总教练员数
      propsLineChartsData: [0, 0, 0, 0, 0], // 教练员数据分析
      propsLoginInfo: {},
      onlineCoachCount: 0,
      propsNumStatistical: {},  //
      propsOrgName: '', // 数据源来自地图组件
      propsTeacherList: [],
      reloadTime: 30000,  // ms
    };
  },

  components: {
    "statistical-com": () => import("./components/DataStatistical"),
    "waterFall-com": () => import("./components/WaterFallData"),
    "map-com": () => import("./EchartsProvince"),
    "pie-com": () => import("./components/classStatistical"),
    "line-com": () => import("./components/CoachAnalyse"),
    "toturial-com": () => import("./components/Tutorial"),
    "tutorial-line-com": () => import("./components/GradeAnalyze"),
    "login-line": () => import("./components/LoginUser"),
    "teacher-com": () => import("./components/Lecture"),
  },

  computed: {
    year() {
      let year = new Date().getFullYear();
      return year; // 如果有需求，返回当前年份，非固定
    },
    orgId() {
      const { id } = this.$route.query;
      return id;
    },
  },

  mounted() {
    
    this.isShowChild = false;
    this.loadCoachInfo();
  },


  methods: {
    toggleApi() {
      const that = this;
      this.$fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
        teleport: this.teleport, // 如果为true， 进入全屏时目标元素会被移动到document.body下；
        callback: (isFullscreen) => {
          that.fullscreen = isFullscreen;
        },
      });
    },

    loadCoachInfo() {
      
      // this.isShowChild = false;  // 数据更新的时候会有闪屏；
      const userType = storageData.getUserType();
      let getParams = {};
      if (userType === "super" || userType === "system") {
        getParams.org_id = this.orgId;
      } else {
        getParams = {};
      }
      getCoachStatisticalOrgan(getParams)
        .then(({ data }) => {
          const {
            failCoachCount,
            passCoachCount,
            totalCoachCount,
            userCount,
            userRankCount,
            loginInfoCount,
            teacherLevelCount,
          } = data.result;
          /* 处理教练员成绩分析 */
          this.propsFailCoachCount = this.changeSourceData(failCoachCount);
          this.propsPassSeriesData = this.changeSourceData(passCoachCount);
          const propsPassRateSeriesData =
            this.changeSourceData(totalCoachCount);
          let propsPassRate = [];
          propsPassRateSeriesData.forEach((item, index) => {
            if (item === 0) {
              propsPassRate.push(0);
            } else {
              const rate = Math.round(
                (this.propsPassSeriesData[index] * 100) / item
              );
              propsPassRate.push(rate);
            }
          });
          this.propsPassRate = propsPassRate;
          /* 处理教练员数据分析 */
          const { groupRankType } = userRankCount;
          this.propsUserCount = userCount;
          let defaultLineChartsData = [0, 0, 0, 0, 0];
          if(groupRankType && groupRankType.length) {
            groupRankType.forEach((item) => {
              const [key, value] = item;
              if (key === "0") defaultLineChartsData[0] = value;
              if (key === "A") defaultLineChartsData[1] = value;
              if (key === "B") defaultLineChartsData[2] = value;
              if (key === "C") defaultLineChartsData[3] = value;
              if (key === "D") defaultLineChartsData[4] = value;
              this.userRankAll = this.userRankAll + value;
            });
          }
          this.propsLineChartsData = defaultLineChartsData;
          /* 处理用户登录数据 逻辑复杂 在组件中处理 */
          // this.propsLoginInfo = loginInfoCount;
          let defaultTeacherList = [0,0,0,0,0]
          teacherLevelCount.forEach(item => {
            if(item.teacher_level === 'A') defaultTeacherList[0] = item.num
            if(item.teacher_level === 'B') defaultTeacherList[1] = item.num
            if(item.teacher_level === 'C') defaultTeacherList[2] = item.num
            if(item.teacher_level === 'D') defaultTeacherList[3] = item.num
            if(item.teacher_level === 'E') defaultTeacherList[4] = item.num
          })
          this.propsTeacherList = defaultTeacherList
          this.isShowChild = true;
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    changeSourceData(list) {
      if (list.length) {
        let defaultList = [0, 0];
        list.forEach((item) => {
          // if (item.class_level === "A") defaultList[0] = item.num;
          // if (item.class_level === "B") defaultList[1] = item.num;
          // if (item.class_level === "C") defaultList[2] = item.num;
          // if (item.class_level === "D") defaultList[3] = item.num;
          if (item.class_level === "C") defaultList[0] = item.num;
          if (item.class_level === "D") defaultList[1] = item.num;
        });
        return defaultList;
      } else {
        return [0,0];
      }
    },

  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.display-wrapper
  width 100%
  height 100%
  background-color #101129 !important
.display-content
  background-color #101129 !important
  min-width 1680px
  max-width 1920px
  min-height 780px
  margin 0 auto
  display flex
  padding 9rem 0.8rem 0
  background url('../../assets/images/display/logo.png') no-repeat 0 0 / contain
  .column
    position relative
    flex 3
    .row
      box-sizing border-box
      border 2px solid red
      border-image url('../../assets/images/display/border.png') 51 38 21 132
      border-width 4.125rem 1.583rem 0.875rem 5.5rem
      position relative
      margin-bottom 2rem
      color #FFFFFF
    .row-content
      position absolute
      top -4rem
      right -1.5rem
      bottom -0.875rem
      left -5.5rem
      padding 1.25rem 2rem
    .class-all
      min-height 150px
      .row-title
        color #68d8fe
        font-weight 600
        font-size 16px
        display flex
        align-items center
        .btn
          display flex
          align-items center
          justify-content center
          width 7rem
          height 2rem
          font-size 0.8rem
          margin 0 5px
          border-radius 2px
          cursor pointer
        .btn-active
          background-color #0bace6
          color #FFFFFF
      .data-wrapper
        display flex
        flex-wrap wrap
        .data-item
          flex 1
          font-size 12px
          text-align center
          .data
            font-size 26px
          .data-title
            color #4c9bfd
            margin-top 5px
    .class-table
      height 350px
      .row-content
        padding 1.25rem 0
      .nav-title-wrapper
        padding-left 1.25rem
        margin-bottom 0.8rem
        .nav-item
          margin-right 15px
          cursor pointer
          color #1950c4
          padding-right 15px
          border-right 2px solid #00f2f1
          &:last-child
            border-right none
        .active-title
          color #FFFFFF
      .table-wrapper
        .table-head
          display flex
          width 100%
          background-color rgba(255, 255, 255, 0.1)
          color #68d8fe
          padding 0 1rem
          line-height 3rem
          .table-column
            /* flex 1 */
            text-align center
            &:nth-child(1)
              width 20%
            &:nth-child(2)
              width 30%
            &:nth-child(3)
              width 20%
            &:nth-child(4)
              width 15%
            &:nth-child(5)
              width 15%
        .table-content
          height 250px
          overflow hidden
          .table-row
            width 100%
            display flex
            padding 0 1rem
            line-height 2.5rem
            color #61a8ff
            &:hover
              background-color rgba(255, 255, 255, 0.1)
              color #68d8fe
            .table-col
              white-space nowrap
              overflow hidden
              text-overflow ellipsis
              text-align center
              &:nth-child(1)
                width 20%
              &:nth-child(2)
                width 30%
              &:nth-child(3)
                width 20%
              &:nth-child(4)
                width 15%
              &:nth-child(5)
                width 15%
  .center
    flex 4
    margin 3.8rem 1.5rem 0
    .map-title
      color #68d8fe
      font-size 1.6rem
      text-align center
    .echart-map
      width 100%
      /* height 440px + 4.875rem */
      height 455px
    .online
      position absolute
      top -18px
      left 0
      z-index 999
      .online-content
        width inherit
        height inherit
        position absolute
        top -40px
        left -56px
        display flex
        flex-direction column
        .title
          width 100%
          color #68d8fe
          font-size 1.6rem
          line-height 4rem
          text-align center
        .content
          flex 1
          font-size 2.4rem
          display flex
          justify-content center
          align-items center
.table-content
  .animation-wrapper
    animation row 20s linear infinite
    &:hover
      animation-play-state paused
.tutorial-add
  height 350px !important
  .data-wrapper
    height 90%
  .echart-tutorial-add
    width 100%
    height 100%
.login-data
  height 340px !important
  .data-wrapper
    height 90%
  .echart-user-login
    width 100%
    height 100%
.class-vip
  height 340px !important
  .data-wrapper
    height 90%
  .echart-class-status
    width 100%
    height 100%
.user-all
  height 340px !important
  margin-top 4.6rem
  .flex-box
    display flex
    width 100%
    height 100%
    .flex-item
      /* flex 1 1 */
      height 100%
      .data-wrapper
        height 90%
    .left
      flex 5
    .right
      flex 2
      padding 8rem 2rem 8rem 2rem
      display flex
      flex-direction column
      justify-content space-around
      font-size 1.4rem
      color #61a8ff
      text-align center
      .line-text
        /* text-align left */
        display flex
        justify-content space-between
        span:nth-child(1)
          display flex
          align-items center
          justify-content flex-start
        span:nth-child(2)
          font-size 2.5rem
          margin-left 5px
          color #FFFFFF
          text-align left
          display block
          width 6rem
  .echart-associate-all
    width 100%
    height 100%
@keyframes row
  0%, 100%
    transform translateY(-50%)
.fullscreen-btn
  color #61a8ff
  cursor pointer
</style>

<style lang="stylus" scoped>
.h290
  height 290px
.echart-map-wrapper
  height 455px
  box-sizing border-box
  padding-bottom 42px
.pie-wrapper
  // height 250px
  height 290px
  width 100%
.line-wrapper
  // height 250px
  height 290px
.grade-wrapper
  height 290px
.login-wrapper
  // height 250px
  height 290px
</style>

<style lang="stylus">
.select-wrapper
  .el-input__inner
    background-color rgba(0, 0, 0, 0)
    border-color #0b93d5
    color #68d8fe
/* .el-select-dropdown */
/* background-color #101129 !important */
/* color #FFFFFF !important */
/* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover */
/* background-color #101129 !important */
/* color #FFFFFF !important */
</style>
